import { render } from "./pdfView.vue?vue&type=template&id=03508ee3&ts=true"
import script from "./pdfView.vue?vue&type=script&lang=ts"
export * from "./pdfView.vue?vue&type=script&lang=ts"

import "./pdfView.vue?vue&type=style&index=0&id=03508ee3&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__